// De vaste teksten van de widget: foutmeldingen, "opnieuw proberen", "even geduld".
//
// Waarom deze naast de teksten uit de database staan: alles wat de winkelier zelf kan aanpassen
// komt uit WidgetTranslate, maar een foutmelding moet er juist zijn op het moment dat de verbinding
// met de server weg is. Die kan dus niet uit de database komen. Besloten door Martijn, 13-09-2026.
//
// Deze opzet stond er al maar werd nergens geïmporteerd: i18next was ingesteld, er stonden
// vertaalbestanden klaar, en drie schermen haalden `t` op zonder het ooit te gebruiken. Sinds WI1
// (13-09-2026) wordt hij in src/index.js geladen en volgt hij de taal van de widget.
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

i18n
    .use(Backend)
    .use(initReactI18next)
    .init({
        // Nederlands is leidend. Staat een tekst niet in de taal van de gast, dan is Nederlands
        // beter dan de sleutel zelf op het scherm.
        fallbackLng: 'nl',

        // De taal komt uit het adres van de widget, niet uit de browser van de gast: een Duitse
        // gast op een Nederlandse site hoort de taal te zien die de winkelier heeft ingesteld.
        // Daarom staat de taaldetectie van de browser er bewust niet in.
        lng: 'nl',

        supportedLngs: ['nl', 'en'],

        // Alleen aanzetten als je zelf zoekt waarom een tekst niet gevonden wordt; anders vult hij
        // de console van elke gast.
        debug: false,

        interpolation: { escapeValue: false },

        // Zonder dit blijft het scherm leeg zolang het vertaalbestand nog binnenkomt. Een lege
        // widget is erger dan een halve tel de terugvaltekst.
        react: { useSuspense: false },

        backend: { loadPath: '/locales/{{lng}}/translation.json' },
    });

// De taal van de widget doorgeven. Wordt aangeroepen zodra bekend is welke taal de winkelier heeft
// ingesteld of de gast heeft gekozen.
export function zetTaal(taalcode) {
    if (!taalcode) return;

    const kort = String(taalcode).toLowerCase().split('-')[0];

    if (i18n.language !== kort) i18n.changeLanguage(kort);
}

export default i18n;
